export const REQUEST_MEDIABASE_PARTNER_LANGUAGES = 'REQUEST_MEDIABASE_PARTNER_LANGUAGES';
export const RECEIVE_MEDIABASE_PARTNER_LANGUAGES = 'RECEIVE_MEDIABASE_PARTNER_LANGUAGES';
export const MEDIABASE_PARTNER_LANGUAGES_FETCH_FAILED = 'MEDIABASE_PARTNER_LANGUAGES_FETCH_FAILED';
